import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Facturás todos los meses pero nunca sabés cuánto ganás realmente.', 'Sentís que trabajás cada vez más y la plata nunca alcanza.', 'No sabés exactamente en qué se va el dinero de tu negocio.', 'Vivís apagando incendios financieros.', 'No tenés un sistema para organizar tus ingresos y gastos.', 'Querés crecer pero siempre te falta dinero para hacerlo.', 'Sentís que tu negocio depende completamente de vos.'];
export function PainPoints() {
  return <section className="py-20 bg-slate-50" data-id="element-302">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-303">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-304">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-305">
            SI TE IDENTIFICÁS CON ALGUNO DE ESTOS PROBLEMAS, ESTE MÉTODO ES PARA
            VOS
          </h2>
          <div className="w-24 h-1 bg-success mx-auto rounded-full" data-id="element-306"></div>
        </motion.div>

        <div className="grid gap-4 md:grid-cols-2 mb-12" data-id="element-307">
          {painPoints.map((point, index) => <motion.div key={index} className={`bg-white p-5 rounded-xl shadow-sm border border-slate-100 flex items-start gap-4 ${index === painPoints.length - 1 ? 'md:col-span-2 md:max-w-lg md:mx-auto w-full' : ''}`} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-308">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-309" />
              <p className="text-slate-700 font-medium" data-id="element-310">{point}</p>
            </motion.div>)}
        </div>

        <motion.div className="bg-navy-900 text-white p-8 rounded-2xl text-center shadow-xl" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-311">
          <p className="text-xl md:text-2xl font-medium mb-4" data-id="element-312">
            La realidad es que la mayoría de los emprendedores{' '}
            <span className="text-red-400 font-bold" data-id="element-313">
              no tiene un problema de ventas.
            </span>
          </p>
          <p className="text-2xl md:text-3xl font-bold text-success mb-6" data-id="element-314">
            Tiene un problema de organización financiera.
          </p>
          <p className="text-lg text-slate-300" data-id="element-315">
            Y eso es exactamente lo que vas a solucionar con Reinicia Tus
            Finanzas.
          </p>
        </motion.div>
      </div>
    </section>;
}